import ToggleButton from '@/components/ToggleButton';

interface Props extends React.LabelHTMLAttributes<HTMLLabelElement> {
  isPerspectiveEnabled: boolean;
  setIsPerspectiveEnabled: (enabled: boolean) => void;
}

function PerspectiveToggle({
  isPerspectiveEnabled,
  setIsPerspectiveEnabled,
  ...delegated
}: Props) {
  return (
    <ToggleButton
      active={isPerspectiveEnabled}
      handleToggle={() =>
        setIsPerspectiveEnabled(!isPerspectiveEnabled)
      }
      {...delegated}
    >
      Show Perspective
    </ToggleButton>
  );
}

export default PerspectiveToggle;
